export interface Installation {
  id: string;
  title: string;
  location: string;
  type: string;
  product: string;
  image: string;
  date: string;
  review: string;
  reviewer: string;
  rating: number;
}

export const installations: Installation[] = [
  {
    id: "i1",
    title: "강남구 아파트 현관 설치",
    location: "서울 강남구",
    type: "아파트",
    product: "NOVA 스마트 도어락 Pro",
    image: "https://public.readdy.ai/ai/img_res/60141142136bd82ab36109d7c77534e0.jpg",
    date: "2026.03.10",
    review: "설치 기사님이 너무 친절하시고 꼼꼼하게 설치해 주셨어요. 지문인식이 정말 빠르고 앱 연동도 완벽합니다. 가족 모두 만족하고 있어요!",
    reviewer: "김지수",
    rating: 5
  },
  {
    id: "i2",
    title: "마포구 오피스텔 보안 강화",
    location: "서울 마포구",
    type: "오피스텔",
    product: "NOVA 지문인식 도어락 Slim",
    image: "https://readdy.ai/api/search-image?query=fingerprint%20door%20lock%20installed%20on%20officetel%20entrance%2C%20modern%20minimalist%20interior%2C%20slim%20design%20door%20lock%20on%20dark%20door%2C%20professional%20installation%2C%20clean%20urban%20living%20space%2C%20soft%20lighting&width=700&height=500&seq=inst2&orientation=landscape",
    date: "2026.03.15",
    review: "혼자 사는 여성으로서 보안이 걱정됐는데 도어준 설치 후 정말 안심이 돼요. 슬림한 디자인도 인테리어에 잘 어울리고 너무 만족합니다.",
    reviewer: "이서연",
    rating: 5
  },
  {
    id: "i3",
    title: "분당 단독주택 전체 보안 시스템",
    location: "경기 성남시 분당구",
    type: "단독주택",
    product: "NOVA 도어락 Pro Max + 보안 시스템",
    image: "https://readdy.ai/api/search-image?query=premium%20smart%20door%20lock%20on%20luxury%20single%20family%20house%20entrance%2C%20elegant%20wooden%20door%20with%20high%20tech%20lock%2C%20beautiful%20home%20exterior%2C%20professional%20security%20installation%2C%20warm%20lighting%2C%20upscale%20residential&width=700&height=500&seq=inst3&orientation=landscape",
    date: "2026.03.20",
    review: "도어락부터 CCTV, 알람 시스템까지 한번에 설치했어요. 스마트폰 하나로 집 전체 보안을 관리할 수 있어서 너무 편리합니다. 강력 추천!",
    reviewer: "박민준",
    rating: 5
  },
  {
    id: "i4",
    title: "강서구 빌라 현관 교체",
    location: "서울 강서구",
    type: "빌라",
    product: "NOVA 번호키 도어락 Basic",
    image: "https://readdy.ai/api/search-image?query=digital%20keypad%20door%20lock%20installed%20on%20villa%20entrance%20door%2C%20clean%20residential%20building%20hallway%2C%20modern%20security%20upgrade%2C%20white%20door%20with%20numeric%20lock%2C%20professional%20installation%2C%20bright%20interior&width=700&height=500&seq=inst4&orientation=landscape",
    date: "2026.03.25",
    review: "가성비 최고예요! 기존 열쇠 도어락에서 교체했는데 설치도 빠르고 사용법도 간단해서 부모님도 쉽게 사용하세요.",
    reviewer: "최도현",
    rating: 4
  },
  {
    id: "i5",
    title: "판교 스타트업 사무실 보안",
    location: "경기 성남시 판교",
    type: "사무실",
    product: "NOVA 스마트 도어락 Pro + 비디오폰",
    image: "https://readdy.ai/api/search-image?query=smart%20office%20door%20lock%20with%20video%20intercom%20installed%20on%20modern%20startup%20office%20entrance%2C%20glass%20door%20with%20electronic%20lock%2C%20professional%20business%20security%2C%20clean%20contemporary%20office%20interior%2C%20bright%20lighting&width=700&height=500&seq=inst5&orientation=landscape",
    date: "2026.04.01",
    review: "직원 출입 관리가 너무 편해졌어요. 앱으로 출입 기록 확인하고 방문객은 비디오폰으로 확인 후 원격으로 문 열어줄 수 있어서 업무 효율이 올라갔습니다.",
    reviewer: "정수빈",
    rating: 5
  },
  {
    id: "i6",
    title: "용산구 고급 주상복합 설치",
    location: "서울 용산구",
    type: "주상복합",
    product: "NOVA 도어락 Pro Max",
    image: "https://readdy.ai/api/search-image?query=luxury%20smart%20door%20lock%20on%20high%20end%20residential%20complex%20entrance%2C%20premium%20interior%20design%2C%20sophisticated%20door%20lock%20installation%2C%20marble%20flooring%20hallway%2C%20upscale%20apartment%2C%20elegant%20lighting%2C%20modern%20luxury%20living&width=700&height=500&seq=inst6&orientation=landscape",
    date: "2026.04.05",
    review: "얼굴인식 기능이 정말 신기하고 편해요. 손이 가득 찼을 때도 그냥 서 있으면 문이 열려요. 디자인도 고급스러워서 인테리어와 완벽하게 어울립니다.",
    reviewer: "한소희",
    rating: 5
  },
  {
    id: "i7",
    title: "수원 신축 아파트 단지 납품",
    location: "경기 수원시",
    type: "아파트 단지",
    product: "NOVA 스마트 도어락 Pro (200세대)",
    image: "https://readdy.ai/api/search-image?query=new%20apartment%20complex%20with%20smart%20door%20locks%20installed%20on%20multiple%20units%2C%20modern%20residential%20building%20hallway%2C%20uniform%20security%20installation%2C%20clean%20contemporary%20Korean%20apartment%20interior%2C%20professional%20bulk%20installation&width=700&height=500&seq=inst7&orientation=landscape",
    date: "2026.04.08",
    review: "신축 아파트 200세대 전체에 도어준을 선택했습니다. 입주민 만족도가 매우 높고 AS 대응도 빠릅니다. 다음 프로젝트에도 도어준과 함께할 예정입니다.",
    reviewer: "이건설 (시공사 담당자)",
    rating: 5
  },
  {
    id: "i8",
    title: "인천 카페 출입 보안 설치",
    location: "인천 연수구",
    type: "상업시설",
    product: "스마트 초인종 비디오폰 + 도어락",
    image: "https://readdy.ai/api/search-image?query=smart%20door%20lock%20and%20video%20doorbell%20installed%20on%20cafe%20entrance%2C%20modern%20commercial%20space%2C%20glass%20door%20with%20electronic%20security%2C%20stylish%20retail%20entrance%2C%20professional%20installation%2C%20warm%20ambient%20lighting&width=700&height=500&seq=inst8&orientation=landscape",
    date: "2026.04.10",
    review: "카페 영업 시간 외 보안이 걱정됐는데 도어준 설치 후 완전히 해결됐어요. 비디오폰으로 방문객 확인하고 원격으로 문 열어줄 수 있어서 너무 편리해요.",
    reviewer: "오민지",
    rating: 5
  }
];

export const installationTypes = ["전체", "아파트", "오피스텔", "단독주택", "빌라", "사무실", "주상복합", "상업시설"];
